
import { motion, AnimatePresence } from 'framer-motion';
import { Progress } from '@/components/ui/progress';

interface AnalysisCardProgressProps {
  isGenerating: boolean;
  progress: number;
  currentStep: string;
}

export function AnalysisCardProgress({ isGenerating, progress, currentStep }: AnalysisCardProgressProps) {
  return (
    <AnimatePresence>
      {isGenerating && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="space-y-2"
        >
          <div className="text-center">
            <p className="text-sm text-purple-700 font-medium">{currentStep}</p>
          </div>
          <Progress value={progress} className="h-2" />
          <p className="text-xs text-center text-muted-foreground">
            {progress}% concluído • Isso pode levar alguns minutos
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
